import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getQueryParams } from 'app/modules/router/selectors'
import { actions as presenceActions, selectors } from 'app/modules/presence'
import { withRouter } from 'react-router'
import { Input } from '@driftt/tide-core-legacy'

const PRESENCE_INTERVAL = 20000
const FILTER_DEBOUNCE = 300

class PresenceFiltersRow extends Component {
  handleChangeNewFilters = filterName => e => {
    const q = e.target.value ? { [filterName]: e.target.value } : undefined
    const { [filterName]: _previousValue, ...rest } = this.props.query
    this.props.router.replace({
      pathname: window.location.pathname,
      query: { ...rest, ...q },
      hash: window.location.hash
    })

    this.props.actions.setNewFilters(this.props.newFilters.set(filterName, e.target.value))
    this.useNewFilters()
  }

  useNewFilters = _.debounce(() => {
    this.props.actions.cancelPresenceInterval()
    this.props.actions.getPresenceStateOnInterval(PRESENCE_INTERVAL)
  }, FILTER_DEBOUNCE)

  render() {
    return <tr>
      { this.props.tableColumns.map(({ label, filter, filterPlaceholder, filterProperty }) =>
            <td key={`${label}-${filterPlaceholder}-${filterProperty}`} className="pr-filter">
              {filter &&
                <Input
                  size="small"
                  type="search"
                  placeholder={filterPlaceholder}
                  onChange={this.handleChangeNewFilters(filterProperty)}
                  value={this.props.newFilters.get(filterProperty)}
                />
              }
            </td>
      )}
    </tr>
  }
}

const mapStateToProps = state => ({
  newFilters: selectors.getNewFilters(state),
  query: getQueryParams(state).toJS()
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setNewFilters: presenceActions.setNewFilters,
      getPresenceStateOnInterval: presenceActions.getPresenceStateOnInterval,
      cancelPresenceInterval: presenceActions.cancelPresenceInterval,
      bootstrapUser: presenceActions.bootstrapUser
    },
    dispatch
  )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PresenceFiltersRow))



// WEBPACK FOOTER //
// ./src/scripts/components/Presence/PresenceFiltersRow/index.js